import styled from "styled-components";
import ArrLeft from "../../../styles/icons/arr-left.svg";
import ArrRight from "../../../styles/icons/arr-right.svg";

const PaginationContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 30px 0 60px 0;
  min-height: 40px;

  & span {
    animation: fadeIn 0.3s ease-in-out;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

const PageNumber = styled.span<{ isActive: boolean }>`
display: inline-flex;
align-items: center;
  justify-content: center;
  
  font-family: "e-Ukraine Head", sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 120%;
  color: #656565;

  width: 25px;
    height: 25px;
  text-align: center;
  line-height: 30px;
  border-radius: 50%;
  cursor: pointer;
  border: ${({ isActive }) => (isActive ? "1px solid #8f8f8f;" : "")};
  transition: all 0.3s ease-in-out;
`;

export const ArrIcon = styled.img<{ disabled: boolean }>`
  cursor: pointer;
  padding: 5px 10px;
  pointer-events: ${({ disabled }) => (disabled ? "none" : "auto")};
  opacity: ${({ disabled }) => (disabled ? "0.5" : "1")};
  transform: scale(1);
  transition: transform 0.2s ease-in-out, opacity 0.3s;

  &:active {
    transform: scale(0.9);
  }
`;

interface PaginationComponentProps {
    totalPages: number;
    currentPage: number;
    onPageChange: (page: number) => void;
  }

const PaginationComponent = ({
  totalPages,
  currentPage,
  onPageChange,
}: PaginationComponentProps) => {
 
    
  const handlePrevClick = () => {
    if (currentPage > 1) onPageChange(currentPage - 1);
    window.scrollTo({ top: 0, left: 0 });
  };

  const handleNextClick = () => {
    if (currentPage < totalPages) onPageChange(currentPage + 1);
    window.scrollTo({ top: 0, left: 0 });
  };

  const handlePageClick = (page: number) => {
    onPageChange(page);
    window.scrollTo({ top: 0, left: 0 });
  };
  

  const getPages = () => {
    const pages = [];
    const maxVisiblePages = 3;

    if (totalPages <= maxVisiblePages + 2) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      pages.push(1);

      if (currentPage > maxVisiblePages) {
        pages.push("...");
      }

      const startPage = Math.max(2, currentPage - 1);
      const endPage = Math.min(totalPages - 1, currentPage + 1);

      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }

      if (currentPage < totalPages - maxVisiblePages + 1) {
        pages.push("...");
      }

      pages.push(totalPages);
    }

    return pages;
  };

  const pages = getPages();

  return (
    <PaginationContainer>
      <ArrIcon
        src={ArrLeft}
        alt="arr-icon"
        onClick={handlePrevClick}
        disabled={currentPage === 1}
      />
      {pages.map((page, index) =>
        page === "..." ? (
          <PageNumber key={`ellipsis-${index}`} isActive={false}>
            ...
          </PageNumber>
        ) : (
          <PageNumber
            key={page}
            isActive={page === currentPage}
            onClick={() => handlePageClick(Number(page))}
          >
            {page}
          </PageNumber>
        )
      )}
      <ArrIcon
        src={ArrRight}
        alt="arr-icon"
        onClick={handleNextClick}
        disabled={currentPage === totalPages}
      />
    </PaginationContainer>
  );
};

export default PaginationComponent;
